import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#fafbfd]">
        <div className="font-mono-tech text-[#5A6270]">
          <span className="inline-block w-2 h-2 bg-[#df4661] mr-2 align-middle animate-pulse" />
          AUTHENTIFIZIERUNG…
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  return children;
}
